<app-knowledge-base-scrape-jobs #jobs></app-knowledge-base-scrape-jobs>
<app-knowledge-base-articles #articles></app-knowledge-base-articles>
